import react, { useState } from 'react';
import i18next from 'i18next';

import LoginView from './LoginView';
import Network from '../../lib/Network';
import { redirect } from '../../lib/environment';

export default function Login() {
  const [message, setMessage] = useState('');
  const onSubmit = async (username, password) => {
    Network.postLogin(username, password)
      .then(result => {
        if (result.status === 'SUCCESS') {
          redirect();
        } else if (result.status === 'FAILURE') {
          setMessage(i18next.t('error.invalidCredentials'));
        } else if (result.code) {
          setMessage(i18next.t('error.internalError'));
        }
      })
      .catch(error => {
        console.log(error);
        setMessage(i18next.t('error.networkError'))
      });
  };
  return <LoginView onSubmit={onSubmit} message={message} />;
}
